export default __webpack_public_path__ + "static/media/2.40d23317.png";